<form #ngFormDirtyCheck="ngForm" [formGroup]="donorEntryForm">
    <div class="ams-title text-uppercase"><span>{{pageTitle}}</span></div>
    <div class="row">
        <div style="text-align:right" class="col-md-3 offset-md-9">
            <button kendoButton [primary]="true" [icon]="'save'" (click)="saveDonorForm('')">
                <span>save</span>
            </button>
            <button kendoButton class="donorEntrySave" style="display: none;"
                (click)="saveDonorForm('dirtyCheck')"></button>
            <button kendoButton [primary]="true" [icon]="'cancel'" (click)="cancelDonorForm()">
                <span>cancel</span>
            </button>
        </div>
    </div>
    <fieldset>
        <legend class="ams-legend-title">&nbsp;&nbsp;Donor Information&nbsp;&nbsp;</legend>
        <div class="row">
            <div class="col-md-3">
                <kendo-textbox-container floatingLabel="Donor Agency Name" class="required-field">
                    <input kendoTextBox value="" style="visibility:hidden; display:none" disabled />
                    <kendo-dropdownlist [data]="donorAgencyList" [textField]="'agencyName'" [valueField]="'donorId'"
                        [valuePrimitive]="true" formControlName="donorAgency" [filterable]="true"
                        (filterChange)="handleDonorAgency($event)" (valueChange)="donorSelectionChange($event)">
                    </kendo-dropdownlist>
                    <span class="gps-validation-error text-left" *ngIf="isDonorAgencyNameValid">Donor agency name is
                        required</span>
                </kendo-textbox-container>
            </div>
            <div class="col-md-3">
                <kendo-textbox-container floatingLabel="Address 1" class="required-field">
                    <input kendoTextBox value="test" formControlName="address1">
                    <span class="gps-validation-error text-left" *ngIf="isAddressValid">Address 1 is required</span>
                </kendo-textbox-container>
            </div>
            <div class="col-md-3">
                <kendo-textbox-container floatingLabel="Address 2">
                    <input kendoTextBox value="test" formControlName="address2">
                </kendo-textbox-container>
            </div>
            <div class="col-md-3">
                <kendo-textbox-container floatingLabel="Address 3">
                    <input kendoTextBox value="test" formControlName="address3">
                </kendo-textbox-container>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3">
                <kendo-textbox-container floatingLabel="City" class="required-field">
                    <input kendoTextBox value="" formControlName="city">
                    <span class="gps-validation-error text-left" *ngIf="isCityValid">City is required</span>
                </kendo-textbox-container>
            </div>
            <div class="col-md-3">
                <kendo-textbox-container floatingLabel="State">
                    <input kendoTextBox value="" formControlName="state">
                </kendo-textbox-container>
            </div>
            <div class="col-md-3">
                <kendo-textbox-container floatingLabel="Zip Code">
                    <input kendoTextBox value="" formControlName="zipcode">
                </kendo-textbox-container>
            </div>
            <div class="col-md-3">
                <kendo-textbox-container floatingLabel="Country" class="required-field">
                    <input kendoTextBox value="" style="visibility:hidden; display:none" disabled />
                    <kendo-dropdownlist [data]="selectedCountryItem" [textField]="'name'"
                        [valueField]="'countryOfficeId'" [valuePrimitive]="true" formControlName="country"
                        [filterable]="true" (filterChange)="handleCountryAgency($event)"
                        (valueChange)="countrySelectionChange($event)">
                    </kendo-dropdownlist>
                    <span class="gps-validation-error text-left" *ngIf="isDonorAgencyNameValid">Donor agency name is
                        required</span>
                </kendo-textbox-container>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3">
                <kendo-textbox-container floatingLabel="URL">
                    <input kendoTextBox value="" formControlName="url">
                </kendo-textbox-container>
            </div>
            <div class="col-md-3">
                <kendo-textbox-container floatingLabel="Active">
                    <input type="checkbox" style="margin-top: 18px;" class="k-checkbox" [checked]="isActive"
                        disabled="true" />
                </kendo-textbox-container>
            </div>
        </div>
    </fieldset>

    <fieldset>
        <legend class="ams-legend-title">&nbsp;&nbsp;Donor Awards and Contacts&nbsp;&nbsp;</legend>
        <kendo-grid [data]="awardContactListGrid" [pageSize]="pageSize" [skip]="skip" (pageChange)="pageChange($event)"
            (dataStateChange)="dataStateChange($event)" (filterChange)="filterChange($event)" [pageable]="{
                buttonCount: buttonCount,
                info: info,
                type: typedg,
                pageSizes: pageSizes,
                previousNext: previousNext 
            }">
            <kendo-grid-column field="">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <label class="k-radio-label">Awards:
                        <span [title]="dataItem.agreementTitle">{{dataItem.agreementTitle}}</span>
                    </label>
                </ng-template>
            </kendo-grid-column>
            <div *kendoGridDetailTemplate="let dataItem">
                <form #ngFormDirtyCheck="ngForm" [formGroup]="contactEntryForm">
                    <kendo-grid [data]="dataItem.contacts" [columnMenu]="{sort: false, filter: false, columnChooser: false}"
                        (edit)="editHandler($event)" (cancel)="cancelHandler($event)"
                        (save)="saveHandler($event, dataItem.agreementId)"
                        (remove)="removeHandler($event, dataItem.agreementId)" (add)="addHandler($event)"
                        style="border-top:none;">
                        <ng-template kendoGridToolbarTemplate>
                            <div class="row w-100">
                                <div style="text-align:right" class="col-md-3 offset-md-9">
                                    <button kendoGridAddCommand [icon]="'add'" [primary]="true">Add new Contact</button>
                                </div>
                            </div>
                        </ng-template>
                        <kendo-grid-column field="name" title="Contact Name">
                            <ng-template kendoGridEditTemplate let-column="column" let-formGroup="formGroup"
                                let-isNew="isNew">
                                <input #name kendoTextBox value="" formControlName="contactName">
                            </ng-template>
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <span [title]="dataItem.name">
                                    <span>{{dataItem.name}} </span>
                                </span>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column field="ContactTitle" title="Contact Title">
                            <ng-template kendoGridEditTemplate let-column="column" let-formGroup="formGroup"
                                let-isNew="isNew">
                                <input #title kendoTextBox value="" formControlName="contactTitle">
                            </ng-template>
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <span [title]="dataItem.title">
                                    <span>{{dataItem.title}} </span>
                                </span>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column field="ContactEmail" title="Contact Email">
                            <ng-template kendoGridEditTemplate let-column="column" let-formGroup="formGroup"
                                let-isNew="isNew">
                                <input #email kendoTextBox value="" formControlName="contactEmail">
                            </ng-template>
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <span [title]="dataItem.email">
                                    <span>{{dataItem.email}} </span>
                                </span>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column field="Notes" title="Notes">
                            <ng-template kendoGridEditTemplate let-column="column" let-formGroup="formGroup"
                                let-isNew="isNew">
                                <input kendoTextBox value="" formControlName="contactNotes">
                            </ng-template>
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <span [title]="dataItem.note">
                                    <span>{{dataItem.note}} </span>
                                </span>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-command-column title="Action">
                            <ng-template kendoGridCellTemplate let-isNew="isNew">
                                <button [icon]="'edit'" kendoGridEditCommand title="edit"></button>
                                <button [icon]="'delete'" kendoGridRemoveCommand title="delete"></button>
                                <button [icon]="isNew ? 'add' : 'save'" [title]="isNew ? 'add' : 'save'" kendoGridSaveCommand></button>
                                <button [icon]="'clear'" kendoGridCancelCommand title="clear"></button>
                            </ng-template>
                        </kendo-grid-command-column>
                    </kendo-grid>
                </form>
            </div>
        </kendo-grid>
    </fieldset>
    <button type="submit" id="submitBtn" class="btn btn-success submit_btn d-none"></button>
</form>